module.exports = __webpack_public_path__ + "img/ringsize.d32f41f.webp";